export const EMPTY_PROSPECT_DATA = {
  gpsCoordinates: '',
  cedula: '',
  email: '',
  phoneNumber: '',
  direccion: '',
  firstName: '',
  lastName: '',
};
